<template>
  <div class="agotados">
    <AppMenu />
    <BaseBreadcrumb title="Productos agotados" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card class="mt-3 mx-3 pa-4">
    <p class="grey--text text--darken-1 mb-3">
      Lo que se marca aquí no se puede pedir en meseros ni en caja. Vuelve solo cuando se abre un turno nuevo, o cuando se quite.
      <template v-if="!puede"><br />Solo administración y caja pueden marcar o quitar productos.</template>
    </p>

    <v-card outlined class="mb-4" v-if="agotados.length">
      <v-card-title class="subtitle-1 pb-0">Agotados ahora ({{ agotados.length }})</v-card-title>
      <v-list>
        <v-list-item v-for="p in agotados" :key="p.id">
          <v-list-item-content><v-list-item-title>{{ p.name }}</v-list-item-title></v-list-item-content>
          <v-list-item-action>
            <v-btn v-if="puede" small depressed color="success" :loading="ocupado === p.id" @click="cambiar(p, false)">Volver a vender</v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

    <ng-text-keyboard v-if="puede" v-model="query" :filled="false" placeholder="Busca el producto que se agotó" append-icon="mdi-magnify"
      hide-details :inputmode="$store.getters.mobile ? 'text' : 'none'" background-color="grey lighten-5" @input="buscar"></ng-text-keyboard>
    <v-list v-if="puede">
      <v-list-item v-for="p in resultados" :key="p.id">
        <v-list-item-content><v-list-item-title>{{ p.name }}</v-list-item-title></v-list-item-content>
        <v-list-item-action>
          <v-chip v-if="esAgotado(p.id)" small color="red darken-1" dark>Agotado</v-chip>
          <v-btn v-else small depressed color="red darken-1" class="white--text" :loading="ocupado === p.id" @click="cambiar(p, true)">Marcar agotado</v-btn>
        </v-list-item-action>
      </v-list-item>
      <div v-if="query && !resultados.length" class="text-center grey--text py-6">No encontramos productos con eso.</div>
    </v-list>
    <div class="red--text caption" v-if="error">{{ error }}</div>
    </v-card>
  </div>
</template>

<script>
import AppMenu from "./menu/AppMenu.vue";
import { esAgotado, listaAgotados, marcarAgotado, puedeMarcarAgotados, vigilarAgotados } from "@/plugins/pos/agotados";

export default {
  name: "ProductosAgotados",
  components: { AppMenu },
  data: () => ({
    breadcrumbs: [
      { text: "Inicio", disabled: false, to: "/pos", "exact-path": true },
      { text: "Productos agotados", disabled: true },
    ],
    query: "", resultados: [], ocupado: null, error: "", espera: null }),
  computed: {
    puede() {
      return puedeMarcarAgotados();
    },
    agotados() {
      return listaAgotados().sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  mounted() {
    vigilarAgotados(this.$http);
  },
  methods: {
    esAgotado,
    buscar() {
      clearTimeout(this.espera);
      this.espera = setTimeout(() => {
        const q = (this.query || "").trim();
        if (q.length < 2) {
          this.resultados = [];
          return;
        }
        this.resultados = this.$db
          .searchProducts({ $or: [{ name: { $regex: [q, "i"] } }, { reference: { $regex: q } }] }, 30)
          .map((p) => ({ id: p.id, name: p.name }));
      }, 250);
    },
    async cambiar(p, agotado) {
      this.ocupado = p.id;
      this.error = "";
      try {
        const r = await marcarAgotado(this.$http, p, agotado);
        if (!r || !r.success) this.error = (r && (r.msg || r.message)) || "No se pudo guardar. Inténtalo de nuevo.";
      } catch (e) {
        this.error = (e && (e.msg || e.message)) || "No se pudo guardar. Revisa la conexión.";
      } finally {
        this.ocupado = null;
      }
    },
  },
};
</script>
